// Query-key constants for the integration link-session-info cache, split from
// the hook module (same pattern as sessionByIdKeys) so imperative cache readers
// (e.g. note generation) can address the cache without pulling the hook's
// query/store dependency chain into their module graph.
export const GET_INTEGRATION_LINK_SESSION_INFO = 'GetIntegrationLinkSessionInfo';
